module.exports = __webpack_public_path__ + "img/gp.f8860c9d.svg";